export const INVOICE_ADDRESS_CONSTANTS = {
  EMAIL_PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
} as const;
